const winnersData = [
  {
    id: 1,
    name: "Y. Pevin Dewnaka",
    image: "/images/programs/winners/pevin.png",
    school: "Grade 7 | Location: Galle",
    description: "Pevin demonstrated exceptional innovation with his robotics project. His solution efficiently combined sensor technology with automated data processing to create a highly effective robot design.",
    position: "1st Place",
    award: "Gold Medal - Junior Champion",
    category: "Junior Category",
    year: "2021"
  },
  {
    id: 2,
    name: "R. W. M. Kavindu Yasas",
    image: "/images/programs/winners/kavindu.png",
    school: "Grade 7 | Location: Kelaniya",
    description: "Kavindu's project showcased outstanding technical knowledge and creativity. His robot design incorporated multiple innovative features for navigation and obstacle detection, earning high marks from all judges.",
    position: "2nd Place",
    award: "Silver Medal",
    category: "Junior Category",
    year: "2021"
  },
  {
    id: 3,
    name: "Nandinu Senath Udugampala",
    image: "/images/programs/winners/nandinu.png",
    school: "Grade 8 | Location: Panadura",
    description: "Nandinu showed impressive skill in both robot design and programming. His project featured a well-designed interface and robust mechanical system that performed exceptionally well in all challenge rounds.",
    position: "3rd Place",
    award: "Bronze Medal",
    category: "Junior Category",
    year: "2021"
  },
  {
    id: 4,
    name: "G. A. Kassapa Liyanage",
    image: "/images/programs/winners/kassapa.png",
    school: "Grade 9 | Location: Panadura",
    description: "Kassapa's innovative approach to robotics engineering earned him the first place in the Senior Category. His project demonstrated exceptional creativity and technical execution in the competition challenges.",
    position: "1st Place",
    award: "Gold Medal - Senior Champion",
    category: "Senior Category",
    year: "2021"
  },
  {
    id: 5,
    name: "R. M. N. Dulnith Rathnayake",
    image: "/images/programs/winners/dulnith.png",
    school: "Grade 9 | Location: Manikhinna",
    description: "Dulnith's project combined excellent programming skills with a thoughtful mechanical design. His robot demonstrated remarkable precision in the technical challenges and reliable performance throughout the competition.",
    position: "2nd Place",
    award: "Silver Medal",
    category: "Senior Category",
    year: "2021"
  },
  {
    id: 6,
    name: "D. Shiwantha Jayanada Kumarasingha",
    image: "/images/programs/winners/shiwantha.png",
    school: "Grade 9 | Location: Panadura",
    description: "Shiwantha presented a remarkable robot design that excelled in both performance and innovation. His project demonstrated excellent problem-solving skills and technical implementation.",
    position: "3rd Place",
    award: "Bronze Medal",
    category: "Senior Category",
    year: "2021"
  }
];

export default winnersData; 